import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/constants/site";

export const WhatsAppFloat = () => (
  <a
    data-testid="whatsapp-float"
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
    className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3.5 text-xs font-semibold uppercase tracking-[0.15em] text-obsidian shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-all duration-300 hover:bg-[#20BD5A] hover:shadow-[0_8px_36px_rgba(37,211,102,0.5)]"
  >
    <MessageCircle size={18} />
    <span className="sm:hidden">Chat</span>
    <span className="hidden sm:inline">Chat With Us</span>
  </a>
);
